const namespaced = true

const state = {
  eventName:'',
  eventLocation:null
}

const mutations = {
  updateEventLocation(state, location) { // Namespaced
    state.eventLocation = location
  },
}

export default {
  namespaced,
  state,
  mutations,
}
